import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  privateMessageContainer: {
    padding: "20px",
    backgroundColor: theme.palette.events.grayPrimary,
    borderRadius: "5px",
    marginBottom: "20px",
    color: theme.palette.events.lightBlack,
    textAlign: "left",
  },
  privateMessageTitle: {
    display: "flex",
    alignItems: "center",
    marginBottom: "4px",
  },
  privateMessageIcon: {
    marginRight: "20px",
    width: "20px",
    height: "20px",
  },
  privateEventText: {
    lineHeight: 1.4,
  },
}));
